<template>
  <layout-basic>
    <h3 class="title is-4">Dashboard</h3>
    <p>No widgets yet</p>
  </layout-basic>
</template>
<script>

import LayoutBasic from '@/layouts/LayoutBasic'

export default {
  name: 'Dashboard',
  components: {
    LayoutBasic
  }
}
</script>
